import axiosInstance from './axios';

// export async function signUp(email: string, password: string, role: UserRole, display_name: string, phone?: string) {
//   try {
//     const endpoint = role === 'merchant' ? '/auth/signupMerchant' : '/auth/signupCustomer';

//     const payload = {
//       email,
//       password,
//       role,
//       name: display_name,
//       ...(role === 'customer' && phone ? { phone } : {}),
//     };

//     const { data } = await axiosInstance.post(endpoint, payload);

//     return { data, error: null };
//   } catch (error) {
//     console.error('Error signing up:', error);
//     return { data: null, error };
//   }
// }

type ApiResp = { success: boolean; message?: string;[key: string]: any };

export async function signIn(
  email: string,
  password: string
): Promise<{ data: ApiResp; error: Error | null }> {
  try {
    const endpoint = '/api/auth/loginCustomer';
    // tell axios what shape to expect
    const { data } = await axiosInstance.post<ApiResp>(endpoint, { email, password });

    if (!data.success) throw new Error(data.message || 'Login failed');
    localStorage.setItem("token", data.token);
    return { data, error: null };
  } catch (error: any) {
    console.error('Error signing in:', error);
    return { data: { success: false, message: error.message }, error };
  }
}

export async function signOut(): Promise<{ error: Error | null }> {
  try {
    await axiosInstance.get('/api/auth/logout');
    return { error: null };
  } catch (error: any) {
    console.error('Error signing out:', error);
    return { error };
  }
}

export async function requestPasswordOTP(
  email: string
): Promise<{ data: ApiResp | null; error: Error | null }> {
  try {
    const endpoint = '/api/auth/CresetPasswordOTP';
    const { data } = await axiosInstance.post<ApiResp>(endpoint, { email });

    if (data.success === false) {
      return { data: null, error: new Error(data.message || 'OTP request failed') };
    }

    return { data, error: null };
  } catch (error: any) {
    console.error('Error requesting password OTP:', error);
    return { data: null, error: new Error(error.message) };
  }
}

export async function resetPassword(
  email: string,
  newPassword: string,
  otp: string
): Promise<{ data: ApiResp | null; error: Error | null }> {
  try {
    const endpoint = '/api/auth/CresetPassword';
    const payload = { email, newPassword, otp };
    const { data } = await axiosInstance.post<ApiResp>(endpoint, payload);

    if (data.success === false) {
      return { data: null, error: new Error(data.message || 'Password reset failed') };
    }

    return { data, error: null };
  } catch (error: any) {
    console.error('Error resetting password:', error);
    return { data: null, error: new Error(error.message) };
  }
}

export async function returnOnboarding(
  order_id: string,
  mobile_number: string
): Promise<{ data: ApiResp; error: Error | null }> {
  try {
    const endpoint = '/api/customer/return-onboarding';
    const { data } = await axiosInstance.post<ApiResp>(endpoint, { order_id, mobile_number });

    if (!data.success) throw new Error(data.message || 'Onboarding failed');
    
    // Standardize token persistence to match regular login flow
    if (data.data?.token) {
      localStorage.setItem("token", data.data.token);
      localStorage.setItem("loginType", "token");
    }
    
    return { data, error: null };
  } catch (error: any) {
    console.error('Error in return onboarding:', error);
    return { data: { success: false, message: error.response?.data?.message || error.message }, error };
  }
}
